/**
 * Ad experiment buckets (adExperimentsConfig.js). The bucket is a random
 * number from 0 to 9 kept in the publisher's localStorage; ten values cannot
 * single anyone out. Without storage, the page draws one for itself.
 * @module lib/adExperiments
 */

const {
  AD_BUCKET_COUNT,
  AD_BUCKET_STORAGE_KEY,
  AD_BUCKET_TARGETING_KEY,
  AD_EXPERIMENTS
} = require('../adExperimentsConfig');

let bucket = null;

function adBucket() {
  if (bucket !== null) return bucket;
  let stored = null;
  try { stored = window.localStorage.getItem(AD_BUCKET_STORAGE_KEY); } catch (_) { /* no storage */ }
  const parsed = Number(stored);
  if (stored !== null && Number.isInteger(parsed) && parsed >= 0 && parsed < AD_BUCKET_COUNT) {
    bucket = parsed;
  } else {
    bucket = Math.floor(Math.random() * AD_BUCKET_COUNT);
    try { window.localStorage.setItem(AD_BUCKET_STORAGE_KEY, String(bucket)); } catch (_) { /* this page only */ }
  }
  return bucket;
}

/** Whether this browser keeps the previous behaviour for `name`. */
function inAdHoldout(name) {
  const experiment = AD_EXPERIMENTS[name];
  return Boolean(experiment && experiment.holdoutBuckets.includes(adBucket()));
}

/** The GAM key-value every request carries: `{ mb: '<bucket>' }`. */
function adBucketTargeting() {
  return { [AD_BUCKET_TARGETING_KEY]: String(adBucket()) };
}

module.exports = { adBucket, inAdHoldout, adBucketTargeting };
